import { BusinessRulesAttributes } from '../../../../constants/constants'
import * as esprima from 'esprima'

interface IRuleField {
    id: string
    [key: string]: unknown
}

export const validateRulesFields = (
    rulesFields: any[],
): { updatedRulesFields: IRuleField[]; isValidated: boolean } => {
    let isValidated = true

    // Store values for all fields
    const fieldValues: Record<string, any> = {}

    //validation requried for Thresholds or not
    let needThresholdValidation = false

    // collect all values
    rulesFields.forEach((item) => {
        const itemId = item.id?.toLowerCase()
        fieldValues[itemId] = item.value
        if (itemId === BusinessRulesAttributes.AGGREGATE_LOW_HIGH) {
            needThresholdValidation = true
        }
    })

    // ----------------------------
    // 2. Run existing validations
    // ----------------------------
    let updatedRulesFields = rulesFields?.map((item) => {
        const itemId = item.id?.toLowerCase()

        // TARGET validation
        if (
            item.required &&
            !item.hide &&
            itemId === BusinessRulesAttributes.TARGET
        ) {
            if (
                !item.value ||
                item.value === null ||
                !item.value?.value ||
                (item.value?.isRelation && !item.value?.value?.includes('.'))
            ) {
                isValidated = false
                return { ...item, errorMessage: 'fieldRequired' }
            }
            return { ...item }
        }

        // SCRIPT validation
        if (
            item.required &&
            item.value &&
            !item.hide &&
            itemId === BusinessRulesAttributes.SCRIPT
        ) {
            const isJavaScript = validateJavaScript(item.value)
            if (!isJavaScript) {
                isValidated = false
                return { ...item, errorMessage: 'invalidScript' }
            }
            return { ...item }
        }
        //  Threshold validation
        // one of the critical threshold is required
        if (
            !item.hide &&
            (itemId === BusinessRulesAttributes.HIGH_CRITICAL_THRESHOLD ||
                itemId === BusinessRulesAttributes.LOW_CRITICAL_THRESHOLD)
        ) {
            const highCriticalThresholdValue =
                fieldValues[BusinessRulesAttributes.HIGH_CRITICAL_THRESHOLD]
            const lowCriticalThresholdValue =
                fieldValues[BusinessRulesAttributes.LOW_CRITICAL_THRESHOLD]
            if (
                (highCriticalThresholdValue === null ||
                    highCriticalThresholdValue === '') &&
                (lowCriticalThresholdValue === null ||
                    lowCriticalThresholdValue === '')
            ) {
                isValidated = false
                return {
                    ...item,
                    errorMessage: 'One of the critical threshold is required',
                }
            }
            return { ...item }
        }
        // Default required validation
        if (
            item.required &&
            !item.hide &&
            (!item.value || item.value === null)
        ) {
            isValidated = false
            return { ...item, errorMessage: 'fieldRequired' }
        }

        return { ...item }
    })

    // -----------------------------------------------------------
    // 3. Threshold VALIDATION:
    // one of the critical threshold is required (added in abouve maping)
    // If threshold has value → corresponding duration must have value
    // If duration has value → corresponding threshold must have value
    // -----------------------------------------------------------
    if (needThresholdValidation) {
        const hasAggregate =
            fieldValues[BusinessRulesAttributes.AGGREGATE_LOW_HIGH]

        const thresholdToDurationMap: Record<string, string> = hasAggregate
            ? {
                  [BusinessRulesAttributes.LOW_CRITICAL_THRESHOLD]:
                      BusinessRulesAttributes.CRITICAL_DURATION,
                  [BusinessRulesAttributes.HIGH_CRITICAL_THRESHOLD]:
                      BusinessRulesAttributes.CRITICAL_DURATION,
                  [BusinessRulesAttributes.LOW_WARNING_THRESHOLD]:
                      BusinessRulesAttributes.WARNING_DURATION,
                  [BusinessRulesAttributes.HIGH_WARNING_THRESHOLD]:
                      BusinessRulesAttributes.WARNING_DURATION,
                  [BusinessRulesAttributes.LOW_INFO_THRESHOLD]:
                      BusinessRulesAttributes.INFO_DURATION,
                  [BusinessRulesAttributes.HIGH_INFO_THRESHOLD]:
                      BusinessRulesAttributes.INFO_DURATION,
              }
            : {
                  [BusinessRulesAttributes.LOW_CRITICAL_THRESHOLD]:
                      BusinessRulesAttributes.LOW_CRITICAL_DURATION,
                  [BusinessRulesAttributes.HIGH_CRITICAL_THRESHOLD]:
                      BusinessRulesAttributes.HIGH_CRITICAL_DURATION,
                  [BusinessRulesAttributes.LOW_WARNING_THRESHOLD]:
                      BusinessRulesAttributes.LOW_WARNING_DURATION,
                  [BusinessRulesAttributes.HIGH_WARNING_THRESHOLD]:
                      BusinessRulesAttributes.HIGH_WARNING_DURATION,
                  [BusinessRulesAttributes.LOW_INFO_THRESHOLD]:
                      BusinessRulesAttributes.LOW_INFO_DURATION,
                  [BusinessRulesAttributes.HIGH_INFO_THRESHOLD]:
                      BusinessRulesAttributes.HIGH_INFO_DURATION,
              }

        const thresholdToDurationMapForSecondField: Record<string, string> =
            hasAggregate
                ? {
                      [BusinessRulesAttributes.LOW_CRITICAL_THRESHOLD]:
                          BusinessRulesAttributes.HIGH_CRITICAL_THRESHOLD,
                      [BusinessRulesAttributes.HIGH_CRITICAL_THRESHOLD]:
                          BusinessRulesAttributes.LOW_CRITICAL_THRESHOLD,
                      [BusinessRulesAttributes.LOW_WARNING_THRESHOLD]:
                          BusinessRulesAttributes.HIGH_WARNING_THRESHOLD,
                      [BusinessRulesAttributes.HIGH_WARNING_THRESHOLD]:
                          BusinessRulesAttributes.LOW_WARNING_THRESHOLD,
                      [BusinessRulesAttributes.LOW_INFO_THRESHOLD]:
                          BusinessRulesAttributes.HIGH_INFO_THRESHOLD,
                      [BusinessRulesAttributes.HIGH_INFO_THRESHOLD]:
                          BusinessRulesAttributes.LOW_INFO_THRESHOLD,
                  }
                : {}

        //if threshold value is there, Add errors to missing corrsponding duration fields
        Object.entries(thresholdToDurationMap).forEach(
            ([threshold, duration]) => {
                const thresholdValue = fieldValues[threshold]
                const durationValue = fieldValues[duration]

                if (
                    thresholdValue &&
                    (durationValue === null ||
                        durationValue === '' ||
                        durationValue === undefined)
                ) {
                    isValidated = false

                    updatedRulesFields = updatedRulesFields.map((item) =>
                        item.id.toLowerCase() === duration
                            ? { ...item, errorMessage: 'fieldRequired' }
                            : item,
                    )
                }
            },
        )

        //if threshold value is there, Add errors to missing corrsponding threshold fields. beacuse duration is mandotrry
        Object.entries(thresholdToDurationMapForSecondField).forEach(
            ([threshold, duration]) => {
                const thresholdValue = fieldValues[threshold]
                const durationValue = fieldValues[duration]

                if (
                    thresholdValue &&
                    (durationValue === null ||
                        durationValue === '' ||
                        durationValue === undefined)
                ) {
                    isValidated = false

                    updatedRulesFields = updatedRulesFields.map((item) =>
                        item.id.toLowerCase() === duration
                            ? { ...item, errorMessage: 'fieldRequired' }
                            : item,
                    )
                }
            },
        )

        //if duration value is there, Add errors to missing corrsponding threshold fields
        Object.entries(thresholdToDurationMap).forEach(
            ([threshold, duration]) => {
                const thresholdValue = fieldValues[threshold]
                const durationValue = fieldValues[duration]

                if (
                    durationValue &&
                    (thresholdValue === null ||
                        thresholdValue === '' ||
                        thresholdValue === undefined)
                ) {
                    isValidated = false

                    updatedRulesFields = updatedRulesFields.map((item) =>
                        item.id.toLowerCase() === threshold
                            ? { ...item, errorMessage: 'fieldRequired' }
                            : item,
                    )
                }
            },
        )
    }
    return { updatedRulesFields, isValidated }
}

const validateJavaScript = (input: any) => {
    try {
        esprima.parseScript(input)
        return true
    } catch (e: any) {
        console.log(e.message)
        return false
    }
}
